import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class EditService extends BaseService<number> {
  public constructor(apiService: ApiService) {
    super(apiService);
  }

  //returns id of inserted object (create), 0 (update, delete) or -1 in case of error
  public override HandleResponse(response: JSON): number | object {
    let responseObject: Object;
    let id: number;
    if (response['result'] == 200) {
      if (response['create']) {
        responseObject = response['create'];
        if (responseObject['insertedId'] != 0) {
          id = responseObject['insertedId'];
          return id;
        } else {
          id = -1;
          return id;
        }
      } else if (response['update']) {
        responseObject = response['update'];
      } else if (response['delete']) {
        responseObject = response['delete'];
      } else {
        return (responseObject = response);
      }
      if (responseObject['affectedRows'] != -1) {
        id = responseObject['insertedId'];
      } else {
        id = -1;
      }
    } else {
      console.log('API Error:', response['result']);
      id = -1;
    }
    return id;
  }
}
